var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCqcAgent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 21,
    viewBox: "0 0 16 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8 9.925-1.7 1.3q-.15.125-.3.013-.15-.113-.1-.288l.65-2.1-1.75-1.4a.27.27 0 0 1-.075-.288Q4.775 7 4.95 7H7.1l.65-2.05q.05-.175.25-.175t.25.175L8.9 7h2.125q.175 0 .237.162a.25.25 0 0 1-.062.288l-1.775 1.4.65 2.1q.05.175-.1.288t-.3-.013zM8 19l-4.675 1.55a.94.94 0 0 1-.913-.125.94.94 0 0 1-.412-.8v-6.35a7.7 7.7 0 0 1-1.475-2.4A7.9 7.9 0 0 1 0 8q0-3.35 2.325-5.675T8 0t5.675 2.325T16 8a7.9 7.9 0 0 1-.525 2.875q-.525 1.35-1.475 2.4v6.35q0 .5-.412.8a.94.94 0 0 1-.913.125zm4.25-6.75Q14 10.5 14 8t-1.75-4.25T8 2 3.75 3.75 2 8t1.75 4.25T8 14t4.25-1.75M4 18.025 8 17l4 1.025v-3.1a8.4 8.4 0 0 1-1.887.787A7.7 7.7 0 0 1 8 16a7.7 7.7 0 0 1-2.112-.287A8.4 8.4 0 0 1 4 14.925z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCqcAgent);
export default __webpack_public_path__ + "static/media/CQC_agent.9e83c5a35bbfd4bffa1282545e2660f6.svg";
export { ForwardRef as ReactComponent };